/* eslint-disable jira/filename-case */
import {
	UFOExperience,
	ExperienceTypes,
	ExperiencePerformanceTypes,
} from '@atlassian/ufo/ufo-experimental';
import { createMarkedJpdExperience } from './createJpdExperience.tsx';
import type { MarkedJPDExperience } from './ExperienceMetadataExtra.types.tsx';

export const projectCreationPollingMarks = {
	PROJECT_CREATION_POLLING_START_MARK: 'project_creation_polling_start',
	PROJECT_CREATION_POLLING_STOP_MARK: 'project_creation_polling_stop',
} as const;

// This experience is used to track the progress of the project template creation async not the whole flow
export const apply: MarkedJPDExperience<{
	readonly PROJECT_CREATION_POLLING_START_MARK: 'project_creation_polling_start';
	readonly PROJECT_CREATION_POLLING_STOP_MARK: 'project_creation_polling_stop';
}> = createMarkedJpdExperience(
	new UFOExperience('jpd.project-template-creation-async', {
		type: ExperienceTypes.Experience,
		performanceType: ExperiencePerformanceTypes.Custom,
		timings: [
			{
				key: 'project_creation_polling',
				startMark: projectCreationPollingMarks.PROJECT_CREATION_POLLING_START_MARK,
				endMark: projectCreationPollingMarks.PROJECT_CREATION_POLLING_STOP_MARK,
			},
		],
	}),
	projectCreationPollingMarks,
);
